import { getCommunitiesNearYou } from '../../../js/api/community';
import { rerenderCommunityList } from '../../../js/components/render-communites';

const communitiesNearYouEl = document.querySelector('section.communities-near-you');
let locationPicker;
let locationPickerInput;
let locationCards;
let locationPickerWrapper;
let locationPickerBtn;
let initialValue;
let currentLocation;
let locationButtonSubmit;
let closeLocationPickerIcon;
let communitiesList;

export const communitiesNearYou = () => {
  if (!communitiesNearYouEl) return;
  locationPickerBtn = communitiesNearYouEl.querySelector('#location-picker');
  closeLocationPickerIcon = communitiesNearYouEl.querySelector('#close-location-icon');
  locationPicker = communitiesNearYouEl.querySelector('.location-picker');
  locationPickerInput = communitiesNearYouEl.querySelector('#location-picker-input');
  locationCards = communitiesNearYouEl.querySelector('#location-cards');
  locationPickerWrapper = communitiesNearYouEl.querySelector('.location-picker__wrapper');
  locationButtonSubmit = communitiesNearYouEl.querySelector('#location-button-submit');
  currentLocation = communitiesNearYouEl.querySelector('#current-location');
  communitiesList = communitiesNearYouEl.querySelector('.communities-list');

  if (locationPickerBtn) {
    locationPickerBtn.addEventListener('click', locationPickerHandler);
    initialValue = locationPickerBtn.innerHTML;
  }
  if (closeLocationPickerIcon) {
    closeLocationPickerIcon.addEventListener('click', closeLocationPicker);
  }
  if (locationButtonSubmit) {
    locationButtonSubmit.addEventListener('click', locationButtonSubmitHandler);
  }
  if (locationPickerInput) {
    locationPickerInput.addEventListener('input', () => locationPickerInputHandler('change'));
    locationPickerInput.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        locationButtonSubmitHandler();
      }
    })
  }
  if (locationPickerWrapper) {
    locationPickerWrapper.addEventListener('click', (e) => e.stopPropagation());
  }
  if (currentLocation) {
    currentLocation.addEventListener('click', currentLocationHandler);
  }
}

const currentLocationHandler = () => {
  closeLocationPicker();
  locationPickerBtn.innerHTML = initialValue;
  if (currentLocation && currentLocation.dataset.latitude && currentLocation.dataset.longitude) {
    renderCommunities(currentLocation.dataset.longitude, currentLocation.dataset.latitude);
  }
}

const locationPickerInputHandler = (type) => {
  if (type === 'change') {
    if (locationCards) {
      locationCards.innerHTML = '';
    }
  }
}

const locationPickerHandler = (e) => {
  e.preventDefault();
  e.stopPropagation();
  if (locationPicker) {
    if (locationPicker.classList.contains('active')) {
      closeLocationPicker();
    } else {
      openLocationPicker();
    }
  }
}

const clickOutsideLocationListener = () => {
  closeLocationPicker();
}

const openLocationPicker = () => {
  if (locationPicker) {
    locationPicker.classList.add('active');
    document.addEventListener('click', clickOutsideLocationListener);
  }
  if (locationPickerInput) {
    locationPickerInput.value = '';
  }
  if (locationCards) {
    clearLocationCards();
  }
}

const clearLocationCards = () => {
  locationCards.innerHTML = '';
}

const closeLocationPicker = () => {
  if (locationPicker) {
    locationPicker.classList.remove('active');
    document.removeEventListener('click', clickOutsideLocationListener);
  }
}

const locationButtonSubmitHandler = () => {
  const { googleApiKey } = communitiesNearYouEl.dataset;
  if (locationPickerInput && googleApiKey) {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${locationPickerInput.value}&components=country:US&key=${googleApiKey}`;
    fetch(url)
      .then(res => res.json())
      .then(res => {
        const parsedResult = parseGeocodingResult(res);
        clearLocationCards();
        addLocationCard(parsedResult);
      })
      .catch(console.error);
  }
}

const addLocationCard = (location) => {
  console.log('location1');
  console.log(location);
  if (locationCards && (location.state || location.city)) {
    const liEl = document.createElement('li');
    const text = location.city + `${location.city ? `, ${location.state}` : `${location.state}`}`
    liEl.innerHTML = text;
    locationCards.appendChild(liEl);
    liEl.addEventListener('click', () => {
      locationPickerBtn.innerHTML = text;
      closeLocationPicker();
      renderCommunities(location.longitude, location.latitude);
    });
  }
}

const renderCommunities = (longitude, latitude) => {
  return getCommunitiesNearYou(longitude, latitude)
    .then((communities) => {
      console.log('communities');
      console.log(communities);
      rerenderCommunityList(communitiesList, communities, false);
    });
}

const parseGeocodingResult = (data) => {
  let city = '';
  let state = '';
  let latitude = '';
  let longitude = '';

  if (data && data.results && data.results.length > 0) {
    const addressComponents = data.results[0].address_components;
    const geometry = data.results[0].geometry;

    for (let component of addressComponents) {
      if (component.types.includes('locality')) {
        city = component.long_name;
      }
      if (component.types.includes('administrative_area_level_1')) {
        state = component.short_name;
      }
    }
    latitude = geometry && geometry.location && geometry.location.lat;
    longitude = geometry && geometry.location && geometry.location.lng;
  }

  return {
    city,
    state,
    latitude,
    longitude,
  };
};



// WEBPACK FOOTER //
// ./src/templates/components/communities-near-you/communities-near-you.js